import { render, staticRenderFns } from "./ExamImageList.vue?vue&type=template&id=2a470be5&scoped=true"
import script from "./ExamImageList.vue?vue&type=script&lang=js"
export * from "./ExamImageList.vue?vue&type=script&lang=js"
import style0 from "./ExamImageList.vue?vue&type=style&index=0&id=2a470be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a470be5",
  null
  
)

export default component.exports